export const taxExemptionLocales = ['en-ap']
export const ucpTaxExemptionLocales = ['en-in']

export const shouldShowBillingCompanyName = (locale: string) =>
  !taxExemptionLocales.includes(locale)